import { Line } from "react-chartjs-2";
import { getChartDatasetsMulti, setLineChartOptionsMulti } from "./utils";

export const ChartTabs = ({measurer, data, tabs, tab, isChartRedraw}) => {

    return (
        <Line
            key={measurer.uuid}            
            data={{
                labels: data[tab].labels,
                datasets: getChartDatasetsMulti(data[tab].data, measurer, tab)
            }}
            options={setLineChartOptionsMulti(measurer, data[tab], tab)}
            redraw={isChartRedraw}
        />                     
    )
}